import axios from 'axios';
import { LoadingProgrammatic as Loading } from 'buefy';
import { DialogProgrammatic as Dialog } from 'buefy';

const baseURL = process.env.VUE_APP_BASE_URL;

const state = {
  notifications: []
};

const getters = {
  allNotifications: (state) => state.notifications
};

const actions = {
  async fetchNotifications({ commit, rootState }) {
    try {
      const response = await axios.get(`${baseURL}/notifications/allNotifications`, {
        headers: {
          'Authorization': rootState.user.authHeader
        }
      });
      commit('setNotifications', response.data);
    } catch (error) {
      console.error('Error fetching notifications:', error);
      Dialog.alert({
        title: 'Error',
        message: 'An error occurred while fetching notification history.',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      });
    }
  },
  async deleteNotification({ rootState, dispatch }, notificationId) {
    const loading = Loading.open();
    try {
      await axios.delete(`${baseURL}/notifications/delete?id=${notificationId}`, {
        headers: {
          'Authorization': rootState.user.authHeader
        }
      });
      loading.close();
      Dialog.alert({
        title: 'Success',
        message: 'Notification deleted successfully!',
        confirmText: 'Ok!',
        type: 'is-success',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa'
      });
      dispatch('fetchNotifications'); // Refresh the history
    } catch (error) {
      loading.close();
      Dialog.alert({
        title: 'Error',
        message: 'An error occurred while deleting the notification.',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      });
      throw error;
    }
  },
  async sendNotification({ rootState, dispatch }, payload) {
    const loading = Loading.open();
    try {
      const response = await axios.post(`${baseURL}/upload/uploadNotification`, payload.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.user.authHeader
        }
      });

      // Prepare notification payload
      const notificationPayload = {
        title: payload.title, // Use title from the payload
        body: payload.body, // Use body from the payload
        data: {
          imageUrl: response.data.url, // Use the uploaded image URL
          imageDesc: ""
        }
      };

      // Call notify-all endpoint
      await axios.post(`${baseURL}/devices/notify-all`, notificationPayload, {
        headers: {
          'Authorization': rootState.user.authHeader
        }
      });

      loading.close();
      Dialog.alert({
        title: 'Success',
        message: 'Notification sent successfully!',
        confirmText: 'Ok!',
        type: 'is-success',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa'
      });
      
      dispatch('fetchNotifications'); // Refresh the history
      
      return response.data;
    } catch (error) {
      loading.close();
      Dialog.alert({
        title: 'Error',
        message: 'An error occurred while sending the notification.',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      });
      throw error;
    }
  }
  ,
  async resendNotification({ rootState, dispatch }, notification) {
    const loading = Loading.open();
    try {
      // Prepare notification payload from existing notification
      const notificationPayload = {
        title: notification.title,
        body: notification.body,
        data: notification.data
      };
      await axios.post(`${baseURL}/devices/notify-all`, notificationPayload, {
        headers: {
          'Authorization': rootState.user.authHeader
        }
      });
      loading.close();
      Dialog.alert({
        title: 'Success',
        message: 'Notification resent successfully!',
        confirmText: 'Ok!',
        type: 'is-success',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa'
      });
      dispatch('fetchNotifications');
    } catch (error) {
      loading.close();
      Dialog.alert({
        title: 'Error',
        message: 'An error occurred while resending the notification.',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      });
      throw error;
    }
  }
};

const mutations = {
  setNotifications: (state, notifications) => (state.notifications = notifications)
};

export default {
  namespaced: true, // Enable namespacing for the module
  state,
  getters,
  actions,
  mutations
};
